import React from 'react'
import { Button, Link } from "@mui/material";
import blogServices from '../services/blogs'

function Blog ({ blog, blogs, setBlogs, handleLogout, user }) {
  const handleLike = async () => {
    const updatedBlog = {
      title: blog.title,
      author: blog.author,
      url: blog.url,
      likes: blog.likes + 1
    }
    
    try {
      const returnedBlog = await blogServices.like(updatedBlog, blog.id)
      setBlogs(blogs.map((b) => (
        b.id === returnedBlog.id ? { ...returnedBlog, user: blog.user } : b
      )))
    } catch (exception) {
      if (exception.response.status === 403) {
        window.alert("Session expired")
        handleLogout()
      }
      else if (exception.response.status === 400) {
        window.alert(exception.response.data.error)
      }
    }
  }
  const handleDelete = async () => {
    if (blog.user.username !== user.username) {
        window.alert("You can only delete your own posts")
    }
    try {
      await blogServices.del(blog.id)
      setBlogs(blogs.filter((b)=> (
        b.id !== blog.id
      )))
    } catch (exception) {
      if (exception.response.status === 403) {
        window.alert("Session expired")
        handleLogout()
      }
      console.log(`exception: ${exception}`)
    }
  }
  return (
    <div className="blog">
        <div className="row">
            <Link
                target="_blank"
                href={blog.url}
                underline="hover"
                style={{
                    color: "orange",
                    fontSize: "20pt"
                }}
            >
                {blog.title}
            </Link>
            <span style={{ display: "flex", flexDirection: "row" }}>
                <h3 style={{ margin: "8px 4px", opacity: "0.9" }}>{blog.user.name}</h3>
                <h3 style={{ margin: "8px" }}>{blog.likes}</h3>
            </span>
        </div>
        <div className="row">
            <h5 style={{ fontStyle: "italic", margin: "4px 0px" }}>{blog.author}</h5>
            <div>
                <Button onClick={handleLike}>Like</Button>
                <Button onClick={handleDelete}>Delete</Button>
            </div>
        </div>
        <h3>Summary:</h3>
        <p className="description">{blog.description}</p>
    </div>
  )
}

export default Blog